<template>
  <div class="reportTable">
    <section ref="print">
      <div class="title">
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <!-- <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li> -->
        </ul>
      </div>
      <!-- 图表 -->
      <div>
        <div>
          <div
            id="main"
            style="width: 100%; height: 400px; background-color: #ffffff"
          ></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest } from "@/api/api1.js";
import { getDay } from "../../utils/reg";
import * as echarts from "echarts";
export default {
  data() {
    return {
      preArrivalList: [],
      // 记录
      record: "",
      room: "",
      total: "",
      userName: localStorage.getItem("cname"),
      allPage: 0,
      // 查询日期
      queryDate: "",
      piesource: "",
      startDate: "",
      endDate: "",
    };
  },
  mounted() {},
  created() {
    this.queryDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.startTimeShow = true;
    this.$parent.endTimeShow = true;
    this.$parent.chaxunvib = true;
    var year = this.queryDate.substring(0, 4);
    var month = this.queryDate.substring(5, 7);
    var day = getDay(year, month);
    this.$parent.startDate = year + "-" + month + "-01";
    this.$parent.endDate = year + "-" + month + "-" + day;
    this.getData();
  },
  methods: {
    doserach() {
      if (new Date(this.$parent.startDate) <= new Date(this.$parent.endDate)) {
        this.getData();
      } else {
        this.$mymessage({
          content: "截止日期必须大于开始日期",
          type: "error",
          time: 3000,
          hasClose: true,
        });
      }
    },
    // 查询
    getData() {
      postRequest("/kanBan/guestSourceStatistics", {
        walkIn: 0,
        startDate: this.$parent.startDate,
        endDate: this.$parent.endDate,
      }).then((res) => {
        if (res.status == 200) {
          let gsList = res.data;
          gsList = gsList.map((v) => {
            return { name: v.name + "(" + v.value + ")", value: v.value };
          });
          this.piesource = gsList;
          
          this.getPie();
        } else {
          that.$mymessage({
            content: res.message,
            type: "error",
            time: 2000,
            hasClose: true,
          });
        }
      });
    },
    // 图形
    getPie() {
      // 绘制图表
      var myChart = echarts.init(document.getElementById("main"));
      // 指定图表的配置项和数据
      var option = {
        //标题
        color: ["#fc8452", "#91cc75", "#fac858", "#ee6666"],
        title: {
          text: "散客",
          subtext: "来源分析",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        //图例
        legend: {
          orient: "vertical",
          left: "left",
        },
        // 饼图数据
        series: [
          {
            name: "散客来源分析",
            type: "pie",
            radius: "50%",
            data: this.piesource,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style scoped>
#main {
  margin-top: 30px;
}
.reportTable {
  height: 100%;
  overflow: scroll;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 40px;
  height: 62px;
}
.title > ul {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 62px;
}
>>> canvas {
  background-color: #ffff;
}
</style>
